import {useContext, useEffect, useState} from 'react';
import axios from '../../../axios';
import {AuthContext} from '../context/authContext';
// import keycloak from "../../../Keycloak";
import {useKeycloak} from '@react-keycloak/web';
import {useLocation, useNavigate} from 'react-router-dom';
import useToken from '../../../components/useToken';

export const useAuthentication = () => {
  const {state, dispatch} = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(true);
  const {token, setToken} = useToken();
  const myParam = useLocation().search;
  const loginStatus = new URLSearchParams(myParam).get('login_status');
  const queryParam = new URLSearchParams(myParam).get('query');
  const {keycloak, initialized} = useKeycloak();
  const navigate = useNavigate();

  const keycloakLogout = () => {
    localStorage.clear();
    dispatch({action: 'logout'});
    keycloak.logout({redirectUri: process.env.REACT_APP_KEYCLOAK_REDIRECT_URI});
    //keycloak.logout({redirectUri:`http://localhost:3000/`});
  };

  const keycloakLogin = () => {
    localStorage.clear();
    keycloak.login({
      redirectUri: `${process.env.REACT_APP_KEYCLOAK_REDIRECT_URI}?login_status=auth`,
    });

    //keycloak.login({redirectUri: `http://localhost:3000?login_status=auth`});
  };

  const keycloakLoginAfterRegistration = () => {
    keycloak.login({
      redirectUri: `${process.env.REACT_APP_KEYCLOAK_REDIRECT_URI}/subscription-choice?login_status=auth`,
    });
    // keycloak.login({redirectUri: `http://localhost:3000/subscription-choice?login_status=auth`});
  };

  const refreshAuth = token => {
    localStorage.setItem('token', token);
    setToken(token);
    dispatch({action: 'login'});
  };

  useEffect(() => {
    keycloak.onAuthLogout = () => {
      localStorage.clear();
    };
  }, []);

  useEffect(() => {
    if (initialized) {
      if (keycloak.authenticated && !token) {
        setIsLoading(true);
        axios
          .get(`${axios.defaults.apiURL}/user/token/get/jwt/${keycloak.token}`)
          .then(function (response) {
            setToken(response.data.token);
            dispatch({action: 'login'});
            setIsLoading(false);
          })
          .catch(function (error) {
            setIsLoading(false);
          });
      } else if (keycloak.authenticated && token) {
        setIsLoading(false);
      } else if (!keycloak.authenticated && token) {
        dispatch({action: 'logout'});
        keycloakLogout();
      } else if (!token) {
        if (loginStatus === 'auth') {
          setIsLoading(true);
        } else {
          dispatch({action: 'logout'});
          setIsLoading(false);
        }
      } else {
        dispatch({action: 'login'});
      }
    }
  }, [keycloak.authenticated, initialized]);

  return {
    isAuthenticated: !!token,
    isLoading,
    keycloakLogout,
    keycloakLogin,
    token,
    keycloakLoginAfterRegistration,
    refreshAuth,
  };
};
